import { appHttpClient } from "../../installations/http/axiosInterfaces";

export const exportCatalogByItems = async (itemIds) => {
  try {
    const response = await appHttpClient.post(
      `/Item/Catalog/Export/ByItems`,
      { itemIds },
      {
        responseType: "blob", // Important for file downloads
      }
    );
    
    // Create a blob URL and trigger download
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `ProductCatalog_${new Date().toISOString().replace(/[:.]/g, "-")}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return { success: true };
  } catch (error) {
    console.error("Error exporting catalog by items:", error);
    throw error;
  }
};

export const exportCatalogByCategories = async (categoryIds) => {
  try {
    const response = await appHttpClient.post(
      `/Category/Catalog/Export`,
      { categoryIds },
      {
        responseType: "blob",
      }
    );
    
    // Create a blob URL and trigger download
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `ProductCatalog_${new Date().toISOString().replace(/[:.]/g, "-")}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return { success: true };
  } catch (error) {
    console.error("Error exporting catalog by categories:", error);
    throw error;
  }
};

export const exportCatalogByItemGroups = async (itemGroupIds) => {
  try {
    const response = await appHttpClient.post(
      `/ItemGroup/Catalog/Export`,
      { itemGroupIds },
      {
        responseType: "blob",
      }
    );
    
    // Create a blob URL and trigger download
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `ProductCatalog_${new Date().toISOString().replace(/[:.]/g, "-")}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    return { success: true };
  } catch (error) {
    console.error("Error exporting catalog by item groups:", error);
    throw error;
  }
};

const catalogService = {
  exportCatalogByItems,
  exportCatalogByCategories,
  exportCatalogByItemGroups,
};

export default catalogService;

